import script from "./NameSearchPage.vue?vue&type=script&lang=ts&setup=true"
export * from "./NameSearchPage.vue?vue&type=script&lang=ts&setup=true"

import "./NameSearchPage.vue?vue&type=style&index=0&id=07c66df4&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-07c66df4"]])

export default __exports__